<template>
  <v-menu location="bottom end">
    <template #activator="{ props }">
      <v-btn v-bind="props" :aria-label="`Opciones de ${item.codigo || item.descripcion}`" icon="mdi-dots-vertical" variant="text" size="small" :disabled="disabled" />
    </template>
    <v-list density="compact" min-width="170" rounded="lg">
      <v-list-item title="Editar" prepend-icon="mdi-pencil-outline" @click="$emit('edit', item)" />
      <v-list-item v-if="item.is_active" title="Quitar" prepend-icon="mdi-trash-can-outline" base-color="error" @click="$emit('remove', item)" />
      <v-list-item v-else title="Restaurar" prepend-icon="mdi-restore" @click="$emit('restore', item)" />
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: 'CatalogEntryMenu',
  props: { item: { type: Object, required: true }, disabled: Boolean },
  emits: ['edit', 'remove', 'restore'],
};
</script>
